module.exports = __webpack_public_path__ + "media/images/corporate-sales/icons/embroidery-cb8c840d2ac599b0ff57805728a1553c.svg";